import React from 'react'
import { Col, Row } from 'reactstrap';
import img1 from '../../../assets/images/IM0201.PNG';
import img4 from "../../../assets/images/IM0203.PNG";
import logo from '../../../assets/images/logo1.PNG';
import './index.css';
import ButtonComponent from '../../../components/ButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightDots } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const Dashboard02 = () => {

  const navigate = useNavigate();

  const handleClickNavigate = () => {
    navigate('/order')
  }

  return (
    <>
      <Row className="w-100 h-100 m-0 bg-black">
            <Col xs="12" lg="4" className="main-dash-02-col">
              <img
                src={img1}
                alt="img1"
                className="w-100 h-100 dashboard-side-img"
              />
            </Col>
            <Col
              xs="12"
              lg="4"
              className="main-dash-02-col d-flex align-items-center justify-content-center"
            >
              <div className="middle-img-content py-4 py-4 text-center">
                <img src={logo} alt="logo" className="middle-img-logo mb-3" />
                <h2>Welcome to Curry king</h2>
                <p className="p-4">
                  Curry King is more than just a meal; it's an experience. We
                  bring the treasures of South Asian spices and the comforts of
                  home-style cooked rice and curry to your busy life. Designed
                  for the discerning palate, our meals are a celebration of
                  flavor and convenience.
                </p>
                <ButtonComponent
                  title="Explore Menu"
                  icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                  onClick={handleClickNavigate}
                  backgroundColor="#FFC100"
                  color="black"
                />
              </div>
            </Col>
            <Col xs="12" lg="4" className="main-dash-02-col">
              <img
                src={img4}
                alt="img1"
                className="w-100 h-100 dashboard-side-img"
              />
            </Col>
          </Row>
    </>
  );
}

export default Dashboard02;